var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 56,
    viewBox: "0 0 73 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5546 37.5096L41.5356 46.3237L36.5519 32.1975L62.5735 23.38L67.5546 37.5096Z",
    fill: "url(#paint0_linear_2040_34456)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4489 32.9955L42.5255 44.5474L65.6562 36.7133L61.5826 25.156L38.4489 32.9955ZM63.413 34.5458C62.6829 34.7929 62.2983 35.578 62.5526 36.3015C62.574 36.3652 62.6071 36.4242 62.6391 36.484L44.7565 42.542C44.7435 42.475 44.7292 42.4097 44.7083 42.3431C44.4541 41.6245 43.6561 41.2414 42.9254 41.4865C42.8593 41.5105 42.7988 41.5413 42.7414 41.5708L40.4933 35.2063C40.5586 35.192 40.6281 35.1814 40.6919 35.159C41.4229 34.912 41.8082 34.1232 41.5542 33.4036C41.5321 33.3378 41.499 33.2788 41.468 33.2192L59.3523 27.1625C59.363 27.2262 59.3779 27.2936 59.3982 27.358C59.6528 28.0797 60.4504 28.4656 61.1808 28.2165C61.2484 28.1948 61.3071 28.1636 61.3674 28.1337L63.6122 34.5005C63.5478 34.5101 63.48 34.522 63.413 34.5458Z",
    fill: "#299FBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0212 35.5241C52.8396 35.464 52.6353 35.4202 52.4034 35.3938L52.9118 36.836C53.1444 36.7274 53.3002 36.589 53.3748 36.4247C53.4516 36.2588 53.4547 36.0784 53.3812 35.8787C53.3218 35.7082 53.2018 35.59 53.0212 35.5241Z",
    fill: "#299FBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.86 33.6458C50.9193 33.8115 51.0319 33.9274 51.2008 33.993C51.3697 34.0586 51.5666 34.1049 51.7943 34.1335L51.3237 32.7982C51.0684 32.8976 50.9112 33.0221 50.8556 33.1684C50.7985 33.3183 50.8016 33.4755 50.86 33.6458Z",
    fill: "#299FBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6642 30.6297C48.3224 31.4234 47.0861 33.9443 47.9024 36.259C48.7175 38.5744 51.2795 39.8056 53.621 39.0139C55.961 38.2189 57.1987 35.7012 56.3828 33.3847C55.5671 31.0721 53.006 29.8361 50.6642 30.6297ZM54.4482 36.7038C54.2896 37.0728 54.0009 37.3735 53.5824 37.608L53.8512 38.3695L52.9906 38.661L52.7391 37.9487C52.4209 38.0443 52.1331 38.1024 51.8737 38.1287C51.6164 38.1543 51.4105 38.1513 51.2527 38.1259L51.2442 37.08C51.3648 37.1053 51.5252 37.1165 51.7243 37.1094C51.9222 37.1031 52.1497 37.069 52.4061 37.006L51.8212 35.3431C51.6218 35.3256 51.4231 35.2995 51.2206 35.2619C51.0197 35.2266 50.8291 35.1667 50.6524 35.0801C50.4755 34.9944 50.3122 34.8721 50.1655 34.7186C50.0242 34.5622 49.9053 34.359 49.8171 34.1067C49.6525 33.6386 49.6479 33.2306 49.8089 32.8856C49.9672 32.5441 50.2502 32.2589 50.6544 32.0374L50.3908 31.2906L51.2513 31.0001L51.5029 31.7114C51.7527 31.6471 51.9765 31.6065 52.1772 31.5958C52.3771 31.579 52.5641 31.5785 52.7414 31.5938L52.7617 32.5969C52.653 32.5865 52.5186 32.5831 52.3583 32.5867C52.2025 32.593 52.0252 32.6149 51.8359 32.6541L52.3783 34.1927C52.5767 34.2099 52.7808 34.239 52.9884 34.2756C53.1959 34.3121 53.391 34.3738 53.574 34.4587C53.7547 34.5451 53.9188 34.6627 54.0669 34.8086C54.2147 34.9564 54.3324 35.1554 54.4211 35.3999C54.5956 35.8992 54.6045 36.3364 54.4482 36.7038Z",
    fill: "#299FBB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M51.0185 27.5023L36.5514 32.1977L40.8082 44.2656L51.0185 27.5023Z",
    fill: "#8CD4D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M51.0185 27.5023L36.5514 32.1977L40.8082 44.2656L51.0185 27.5023Z",
    fill: "#8CD4D4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3034 16.9319L42.3047 37.4241L30.8432 27.6108L48.8431 7.11784L60.3034 16.9319Z",
    fill: "url(#paint1_linear_2040_34456)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8855 27.3687L42.2614 35.3932L58.2618 17.1766L48.8864 9.14931L32.8855 27.3687ZM55.2245 16.4023C54.7205 16.9763 54.7856 17.8487 55.3717 18.351C55.4248 18.3971 55.483 18.4314 55.5398 18.4683L43.1688 32.5508C43.1226 32.4992 43.0789 32.45 43.0261 32.402C42.4424 31.9031 41.5591 31.9633 41.0533 32.5369C41.0076 32.5881 40.9712 32.6469 40.9365 32.7022L35.7711 28.2802C35.8203 28.2365 35.8743 28.1937 35.919 28.1423C36.4243 27.5666 36.3584 26.693 35.7731 26.1919C35.72 26.1458 35.6621 26.1096 35.605 26.0745L47.9779 11.9924C48.0205 12.0424 48.065 12.0927 48.116 12.1394C48.7022 12.6407 49.5876 12.58 50.0906 12.0058C50.1395 11.9532 50.1736 11.8959 50.2102 11.8411L55.3745 16.2637C55.3236 16.3062 55.2707 16.3482 55.2245 16.4023Z",
    fill: "#299FBB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7479 22.3757C46.5613 22.4106 46.3606 22.4741 46.1488 22.566L47.3182 23.569C47.4637 23.3602 47.5296 23.1629 47.5102 22.9831C47.4909 22.8024 47.402 22.643 47.2395 22.5061C47.0996 22.3843 46.9371 22.3423 46.7479 22.3757Z",
    fill: "#299FBB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9291 21.8117C44.0643 21.9269 44.2206 21.9706 44.3996 21.9451C44.5806 21.919 44.772 21.8635 44.9822 21.7753L43.8993 20.8489C43.7299 21.0602 43.6574 21.2455 43.6835 21.4001C43.7109 21.5579 43.7923 21.6943 43.9291 21.8117Z",
    fill: "#299FBB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2325 19.2884C40.6139 21.1324 40.8233 23.9325 42.7015 25.5409C44.5778 27.1489 47.4151 26.9553 49.0355 25.1125C50.6542 23.2685 50.4465 20.4697 48.5666 18.86C46.69 17.2529 43.8531 17.4447 42.2325 19.2884ZM48.5785 22.6972C48.6288 23.0961 48.5315 23.4989 48.2895 23.9111L48.9065 24.4367L48.3106 25.1159L47.732 24.6209C47.5052 24.8617 47.2882 25.0553 47.0785 25.2043C46.8688 25.3533 46.6886 25.454 46.5398 25.5066L46.0009 24.603C46.1185 24.5651 46.2614 24.4967 46.4317 24.3913C46.5983 24.2901 46.7792 24.1485 46.9676 23.9671L45.6201 22.8106C45.4393 22.8935 45.252 22.9693 45.0593 23.0373C44.8696 23.1049 44.6737 23.1478 44.4758 23.159C44.2805 23.1727 44.0766 23.1476 43.874 23.0845C43.6706 23.0203 43.4666 22.9012 43.2641 22.7266C42.8832 22.4004 42.6734 22.0492 42.6362 21.6694C42.6001 21.2946 42.7004 20.9071 42.9366 20.5153L42.3312 19.9958L42.9259 19.3183L43.5044 19.8133C43.6867 19.6327 43.8605 19.4878 44.0266 19.3787C44.1922 19.2666 44.3533 19.1741 44.5142 19.0983L45.0384 19.96C44.9391 20.0042 44.8226 20.0678 44.686 20.1501C44.5531 20.2331 44.4122 20.3381 44.2698 20.4673L45.5171 21.5357C45.697 21.4526 45.8889 21.3786 46.0863 21.3066C46.2835 21.2356 46.4832 21.1933 46.683 21.1766C46.8823 21.1627 47.0842 21.1826 47.2854 21.2375C47.4896 21.2921 47.6926 21.4061 47.892 21.5763C48.2987 21.9268 48.5259 22.3008 48.5785 22.6972Z",
    fill: "#299FBB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M41.6099 15.3216L40.6585 36.0158L30.7551 28.0862L41.6099 15.3216Z",
    fill: "#8CD4D4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0083 2.90721L38.8525 29.5883L23.9839 26.7183L29.139 0.0361851L44.0083 2.90721Z",
    fill: "url(#paint2_linear_2040_34456)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6243 25.5011L37.7859 27.8469L42.3693 4.1281L30.2071 1.78019L25.6243 25.5011ZM39.3561 4.95273C39.2115 5.70011 39.7099 6.42689 40.4697 6.57284C40.5375 6.58738 40.607 6.58756 40.6748 6.59134L37.1309 24.9269C37.0643 24.9058 37.0006 24.8851 36.9313 24.8683C36.1732 24.7237 35.4415 25.2113 35.2966 25.9606C35.2839 26.0287 35.2813 26.0958 35.2778 26.1617L28.5765 24.8677C28.5977 24.8061 28.6223 24.7421 28.6359 24.6742C28.7796 23.9266 28.2793 23.1995 27.5206 23.0528C27.4524 23.0401 27.3835 23.0371 27.3174 23.0346L30.8624 4.69828C30.9239 4.72045 30.9893 4.74238 31.0571 4.75692C31.8164 4.90572 32.5497 4.41444 32.6932 3.66783C32.7083 3.59722 32.7096 3.5319 32.7121 3.4658L39.4144 4.75997C39.3924 4.82049 39.3688 4.88461 39.3561 4.95273Z",
    fill: "#299FBB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0635 14.327C34.9185 14.4488 34.7804 14.6023 34.6422 14.7881L36.1596 15.0815C36.1812 14.8281 36.1367 14.6251 36.029 14.4778C35.9211 14.3315 35.7642 14.2378 35.5532 14.1986C35.373 14.1622 35.2094 14.2053 35.0635 14.327Z",
    fill: "#299FBB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3445 15.2262C32.5194 15.2596 32.6754 15.221 32.8173 15.1103C32.9601 14.9998 33.0975 14.856 33.2358 14.6751L31.8296 14.4043C31.7899 14.671 31.8215 14.8697 31.9226 14.9893C32.0268 15.1133 32.1661 15.1911 32.3445 15.2262Z",
    fill: "#299FBB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6003 13.8711C29.1369 16.2722 30.7378 18.5994 33.1723 19.0729C35.6084 19.5428 37.9606 17.9759 38.4259 15.5751C38.8883 13.1739 37.2912 10.8474 34.8526 10.3751C32.4174 9.90537 30.0646 11.4702 29.6003 13.8711ZM36.808 13.7029C37.0518 14.0241 37.1727 14.4224 37.1724 14.8981L37.9719 15.0524L37.8004 15.9337L37.0508 15.7907C36.9777 16.1108 36.8873 16.3867 36.7816 16.6187C36.6767 16.8517 36.5717 17.027 36.4699 17.1481L35.5476 16.6274C35.63 16.537 35.719 16.4057 35.8128 16.2323C35.9054 16.0606 35.9889 15.848 36.0598 15.5979L34.31 15.2593C34.1959 15.4202 34.0726 15.5784 33.9403 15.732C33.8099 15.8859 33.6632 16.0172 33.4992 16.1258C33.3372 16.2337 33.1484 16.3122 32.9411 16.3589C32.7323 16.4023 32.4969 16.3997 32.2325 16.3477C31.738 16.254 31.3794 16.0504 31.1562 15.7397C30.9333 15.4321 30.824 15.0458 30.8286 14.5886L30.0434 14.4369L30.2141 13.5544L30.9633 13.6994C31.0296 13.4533 31.1063 13.2404 31.1958 13.0642C31.2818 12.8854 31.3742 12.7254 31.4733 12.5813L32.3644 13.0698C32.302 13.158 32.2324 13.2694 32.1554 13.4098C32.0831 13.5461 32.015 13.7077 31.9564 13.8916L33.5751 14.2038C33.6891 14.0429 33.8156 13.8834 33.9508 13.7245C34.0842 13.5652 34.2356 13.4298 34.3993 13.3173C34.5658 13.2063 34.7496 13.123 34.952 13.0715C35.1555 13.0192 35.3884 13.0194 35.6466 13.0683C36.1746 13.1712 36.5618 13.3841 36.808 13.7029Z",
    fill: "#299FBB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2258 44.1575C20.2258 44.9178 19.6773 45.5346 18.9979 45.5346H7.9472C7.26874 45.5346 6.71924 44.9178 6.71924 44.1575L8.76423 36.9582C9.15302 35.9188 9.31374 35.5801 9.99219 35.5801H16.951C17.6294 35.5801 18.0172 36.2816 18.1799 36.9582L20.2258 44.1575Z",
    fill: "url(#paint3_linear_2040_34456)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9976 44.4428H7.94695C7.46674 44.4428 7.05485 44.1311 6.85372 43.6816L6.71899 44.1561C6.71899 44.9163 7.2685 45.5332 7.94695 45.5332H18.9976C19.677 45.5332 20.2256 44.9163 20.2256 44.1561L20.0899 43.6816C19.8888 44.1311 19.4778 44.4428 18.9976 44.4428Z",
    fill: "#F5D5A4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5918 44.1575C33.5918 44.9178 33.0413 45.5346 32.3648 45.5346H21.3132C20.6337 45.5346 20.0852 44.9178 20.0852 44.1575L22.1321 36.9582C22.5209 35.9188 22.6816 35.5801 23.3601 35.5801H30.3179C30.9954 35.5801 31.3842 36.2816 31.5458 36.9582L33.5918 44.1575Z",
    fill: "url(#paint4_linear_2040_34456)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.365 44.4428H21.3134C20.8332 44.4428 20.4223 44.1311 20.2211 43.6816L20.0854 44.1561C20.0854 44.9163 20.634 45.5332 21.3134 45.5332H32.365C33.0425 45.5332 33.592 44.9163 33.592 44.1561L33.4564 43.6816C33.2543 44.1311 32.8443 44.4428 32.365 44.4428Z",
    fill: "#F5D5A4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9587 44.1575C46.9587 44.9178 46.4092 45.5346 45.7308 45.5346H34.6801C34.0007 45.5346 33.4521 44.9178 33.4521 44.1575L35.4991 36.9582C35.8879 35.9188 36.0486 35.5801 36.728 35.5801H43.6848C44.3642 35.5801 44.7501 36.2816 44.9128 36.9582L46.9587 44.1575Z",
    fill: "url(#paint5_linear_2040_34456)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7308 44.4428H34.6801C34.1999 44.4428 33.788 44.1311 33.5869 43.6816L33.4521 44.1561C33.4521 44.9163 34.0007 45.5332 34.6801 45.5332H45.7308C46.4092 45.5332 46.9587 44.9163 46.9587 44.1561L46.824 43.6816C46.6219 44.1311 46.212 44.4428 45.7308 44.4428Z",
    fill: "#F5D5A4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9094 34.2044C26.9094 34.9656 26.359 35.5805 25.6805 35.5805H14.6308C13.9533 35.5805 13.4038 34.9656 13.4038 34.2044L15.4507 27.0041C15.8395 25.9647 16.0002 25.627 16.6777 25.627H23.6365C24.314 25.627 24.7028 26.3285 24.8635 27.0041L26.9094 34.2044Z",
    fill: "url(#paint6_linear_2040_34456)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6815 34.4897H14.6308C14.1515 34.4897 13.7416 34.1789 13.5376 33.7285L13.4028 34.2039C13.4028 34.9651 13.9523 35.5801 14.6298 35.5801H25.6805C26.359 35.5801 26.9094 34.9651 26.9094 34.2039L26.7747 33.7285C26.5726 34.1789 26.1617 34.4897 25.6815 34.4897Z",
    fill: "#F5D5A4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2754 34.2044C40.2754 34.9656 39.7249 35.5805 39.0474 35.5805H27.9958C27.3173 35.5805 26.7678 34.9656 26.7678 34.2044L28.8138 27.0041C29.2026 25.9647 29.3642 25.627 30.0408 25.627H37.0005C37.679 25.627 38.0658 26.3285 38.2275 27.0041L40.2754 34.2044Z",
    fill: "url(#paint7_linear_2040_34456)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0462 34.4897H27.9955C27.5153 34.4897 27.1054 34.1789 26.9033 33.7285L26.7676 34.2039C26.7676 34.9651 27.3171 35.5801 27.9955 35.5801H39.0462C39.7237 35.5801 40.2742 34.9651 40.2742 34.2039L40.1385 33.7285C39.9383 34.1789 39.5264 34.4897 39.0462 34.4897Z",
    fill: "#F5D5A4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.522 24.2483C33.522 25.0086 32.9725 25.6255 32.294 25.6255H21.2424C20.5649 25.6255 20.0144 25.0086 20.0144 24.2483L22.0623 17.049C22.4501 16.0087 22.6108 15.6719 23.2883 15.6719H30.248C30.9265 15.6719 31.3143 16.3725 31.4741 17.049L33.522 24.2483Z",
    fill: "url(#paint8_linear_2040_34456)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M32.294 24.5347H21.2423C20.7621 24.5347 20.3512 24.2238 20.1491 23.7734L20.0134 24.2488C20.0134 25.0091 20.5639 25.626 21.2414 25.626H32.293C32.9705 25.626 33.521 25.0091 33.521 24.2488L33.3853 23.7734C33.1851 24.2238 32.7732 24.5347 32.294 24.5347Z",
    fill: "#F5D5A4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5076 54.1106C13.5076 54.8718 12.9581 55.4887 12.2796 55.4887H1.22894C0.549517 55.4887 0.000976562 54.8718 0.000976562 54.1106L2.04693 46.9103C2.43572 45.871 2.59547 45.5332 3.27393 45.5332H10.2327C10.9111 45.5332 11.298 46.2348 11.4597 46.9103L13.5076 54.1106Z",
    fill: "url(#paint9_linear_2040_34456)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2796 54.396H1.22892C0.748709 54.396 0.337784 54.0861 0.13569 53.6348L0 54.1102C0 54.8714 0.549503 55.4883 1.22796 55.4883H12.2786C12.9571 55.4883 13.5066 54.8714 13.5066 54.1102L13.3719 53.6348C13.1707 54.0861 12.7588 54.396 12.2796 54.396Z",
    fill: "#F5D5A4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8731 54.1106C26.8731 54.8718 26.3245 55.4887 25.6451 55.4887H14.5954C13.916 55.4887 13.3684 54.8718 13.3684 54.1106L15.4134 46.9103C15.8012 45.871 15.9629 45.5332 16.6414 45.5332H23.5992C24.2776 45.5332 24.6654 46.2348 24.8271 46.9103L26.8731 54.1106Z",
    fill: "url(#paint10_linear_2040_34456)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6453 54.396H14.5956C14.1145 54.396 13.7055 54.0861 13.5014 53.6348L13.3677 54.1102C13.3677 54.8714 13.9162 55.4883 14.5947 55.4883H25.6444C26.3238 55.4883 26.8723 54.8714 26.8723 54.1102L26.7376 53.6348C26.5355 54.0861 26.1246 54.396 25.6453 54.396Z",
    fill: "#F5D5A4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2395 54.1106C40.2395 54.8718 39.691 55.4887 39.0125 55.4887H27.9599C27.2814 55.4887 26.7319 54.8718 26.7319 54.1106L28.7789 46.9103C29.1667 45.871 29.3284 45.5332 30.0068 45.5332H36.9646C37.6431 45.5332 38.0299 46.2348 38.1916 46.9103L40.2395 54.1106Z",
    fill: "url(#paint11_linear_2040_34456)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0118 54.396H27.9601C27.4799 54.396 27.0699 54.0861 26.8679 53.6348L26.7312 54.1102C26.7312 54.8714 27.2817 55.4883 27.9592 55.4883H39.0108C39.6893 55.4883 40.2378 54.8714 40.2378 54.1102L40.1021 53.6348C39.9029 54.0861 39.491 54.396 39.0118 54.396Z",
    fill: "#F5D5A4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6763 54.1106C53.6763 54.8718 53.1258 55.4887 52.4474 55.4887H41.3977C40.7192 55.4887 40.1707 54.8718 40.1707 54.1106L42.2176 46.9103C42.6044 45.871 42.7661 45.5332 43.4446 45.5332H50.4024C51.0799 45.5332 51.4677 46.2348 51.6294 46.9103L53.6763 54.1106Z",
    fill: "url(#paint12_linear_2040_34456)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4478 54.396H41.3981C40.9189 54.396 40.507 54.0861 40.3049 53.6348L40.1702 54.1102C40.1702 54.8714 40.7187 55.4883 41.3972 55.4883H52.4469C53.1253 55.4883 53.6758 54.8714 53.6758 54.1102L53.5401 53.6348C53.339 54.0861 52.929 54.396 52.4478 54.396Z",
    fill: "#F5D5A4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2040_34456",
    x1: 39.5838,
    y1: 39.2658,
    x2: 63.9302,
    y2: 30.6503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EA814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#62A914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    stopColor: "#6DAD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9721,
    stopColor: "#7FB410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B510"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2040_34456",
    x1: 37.0425,
    y1: 32.2549,
    x2: 53.6982,
    y2: 12.7633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EA814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#62A914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    stopColor: "#6DAD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9721,
    stopColor: "#7FB410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B510"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2040_34456",
    x1: 31.5997,
    y1: 27.7225,
    x2: 36.2779,
    y2: 2.51819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EA814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#62A914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    stopColor: "#6DAD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9721,
    stopColor: "#7FB410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B510"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2040_34456",
    x1: 13.4725,
    y1: 45.534,
    x2: 13.4725,
    y2: 35.5797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0992,
    stopColor: "#FF8B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#FFA10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4713,
    stopColor: "#FFB110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6927,
    stopColor: "#FFBA13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2040_34456",
    x1: 26.8387,
    y1: 45.534,
    x2: 26.8387,
    y2: 35.5797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0992,
    stopColor: "#FF8B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#FFA10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4713,
    stopColor: "#FFB110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6927,
    stopColor: "#FFBA13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2040_34456",
    x1: 40.2053,
    y1: 45.534,
    x2: 40.2053,
    y2: 35.5797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0992,
    stopColor: "#FF8B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#FFA10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4713,
    stopColor: "#FFB110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6927,
    stopColor: "#FFBA13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2040_34456",
    x1: 20.1564,
    y1: 35.5802,
    x2: 20.1564,
    y2: 25.6268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0992,
    stopColor: "#FF8B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#FFA10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4713,
    stopColor: "#FFB110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6927,
    stopColor: "#FFBA13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2040_34456",
    x1: 33.5214,
    y1: 35.5802,
    x2: 33.5214,
    y2: 25.6268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0992,
    stopColor: "#FF8B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#FFA10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4713,
    stopColor: "#FFB110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6927,
    stopColor: "#FFBA13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2040_34456",
    x1: 26.7681,
    y1: 25.6253,
    x2: 26.7681,
    y2: 15.6719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0992,
    stopColor: "#FF8B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#FFA10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4713,
    stopColor: "#FFB110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6927,
    stopColor: "#FFBA13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2040_34456",
    x1: 6.75437,
    y1: 55.4882,
    x2: 6.75437,
    y2: 45.5335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0992,
    stopColor: "#FF8B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#FFA10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4713,
    stopColor: "#FFB110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6927,
    stopColor: "#FFBA13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2040_34456",
    x1: 20.1203,
    y1: 55.4882,
    x2: 20.1203,
    y2: 45.5335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0992,
    stopColor: "#FF8B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#FFA10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4713,
    stopColor: "#FFB110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6927,
    stopColor: "#FFBA13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2040_34456",
    x1: 33.4854,
    y1: 55.4882,
    x2: 33.4854,
    y2: 45.5335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0992,
    stopColor: "#FF8B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#FFA10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4713,
    stopColor: "#FFB110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6927,
    stopColor: "#FFBA13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2040_34456",
    x1: 46.9233,
    y1: 55.4882,
    x2: 46.9233,
    y2: 45.5335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0992,
    stopColor: "#FF8B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#FFA10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4713,
    stopColor: "#FFB110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6927,
    stopColor: "#FFBA13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5);
export default __webpack_public_path__ + "static/media/Group (5).bf85b92ac62cfbfa23549f01a1606d6d.svg";
export { ForwardRef as ReactComponent };